import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { FormCheckbox, FormCheckboxGroup } from 'types/cms';

import { FormControlLabel, FormGroup, FormLabel, Checkbox as MuiCheckbox } from '@material-ui/core';

type CheckboxControllerType = {
  name: string;
  control: Control;
  label: string;
  required: boolean;
};

const CheckboxController = ({ name, control, label, required }: CheckboxControllerType) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ onChange, value, ...rest }) => (
        <FormControlLabel
          {...rest}
          value={value}
          onChange={() => onChange(!value)}
          control={<MuiCheckbox required={required} />}
          label={required ? `${label} *` : label}
        />
      )}
    />
  );
};

export const Checkbox = ({
  control,
  identifier,
  display_value,
  required,
}: FormCheckbox & { control: Control }) => {
  return (
    <CheckboxController
      name={identifier}
      control={control}
      label={display_value ? display_value : identifier}
      required={required}
    />
  );
};

export const CheckboxGroup = ({
  control,
  identifier,
  checkbox_items,
  label,
}: FormCheckboxGroup & { control: Control }) => {
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      {checkbox_items.map(checkbox => {
        const key = `checkbox-item-${checkbox.id}`;
        return (
          <CheckboxController
            key={key}
            name={`${identifier}.${checkbox.identifier}`}
            control={control}
            label={checkbox.display_value ? checkbox.display_value : checkbox.identifier}
            required={checkbox.required}
          />
        );
      })}
    </FormGroup>
  );
};
